// Initialiser Alertify
window.initializeCocoon = function() {
  require("@nathanvda/cocoon")
}
$(document).on("turbolinks:load", function(){
  initializeCocoon();
});
